import * as React from 'react';
import { createRoot } from 'react-dom/client';
import MainApp from './App';

// Create root should be outside of the render function
const container = document.getElementById('root');
const root = createRoot(container!);

// Render the main component, store and intl
const render = (Component: () => React.JSX.Element): void => {
  root.render(<Component />);
};

render(MainApp);
